import React from 'react';
import { Select } from '@common/components';
import { useQuery } from '@common/hooks';
import { SCHEDULE_GROUP_SKILLS_QUERY } from '@load-balancing/graphql/queries/schedule-group-skills';
import {
  buildSkillOptions,
  filterByLabel,
} from './_schedule-worker-skills-select-service';

export function ScheduleWorkerSkillsSelect({
  value,
  onChange,
  scheduleGroupId,
  disabled = false,
  loading = false,
}: {
  value: string[];
  onChange: (skillUuids: string[]) => void;
  scheduleGroupId: string;
  disabled?: boolean;
  loading?: boolean;
}) {
  const { data, loading: catalogLoading } = useQuery(
    SCHEDULE_GROUP_SKILLS_QUERY,
    {
      variables: { scheduleGroupId },
      skip: !scheduleGroupId,
    }
  );

  return (
    <Select<string[]>
      mode="multiple"
      allowClear
      value={value}
      onChange={onChange}
      options={buildSkillOptions(data?.scheduleGroupSkills ?? [])}
      filterOption={filterByLabel}
      loading={loading || catalogLoading}
      disabled={disabled}
      placeholder="Select skills"
    />
  );
}
